import React from 'react';
import ProductAdvertising from '../../../components/ProductAdvertising';
import { useIntl } from 'react-intl';

const Homepage = () => {

    const textTranslator = useIntl();

    const data = {
        id: 28,
        id_en: 341,
        context: 'homepage',
        title: textTranslator.formatMessage({ id: 'products.blocs.homepage' })
    }
    return (
        <div>
            <ProductAdvertising data={data} />
        </div>
    );
};

export default Homepage;